<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-text>
          <modalDialog ref="userfm">
            <template v-slot:trigger-btn>
              <v-icon>add</v-icon>New Staff
            </template>

            <template v-slot:modal-title>New Staff</template>

            <template v-slot:modal-content>
              <v-card>
                <v-card-text>
                  <v-form v-model="valid" :lazy-validation="lazy" ref="form">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-switch
                          v-model="new_user_model.active"
                          style="margin-top: 10px"
                          color="pink darken-1"
                          :true-value="1"
                          :false-value="0"
                          label="Account Status"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Full Name"
                          v-model="new_user_model.name"
                          :rules="rules.required"
                          hint="please make sure that staff names are unique for easy identification purposes."
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Phone No."
                          v-model="new_user_model.phone"
                          :rules="rules.required"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Email"
                          v-model="new_user_model.email"
                          :rules="rules.required"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="editedIndex == -1">
                        <v-text-field
                          label="Password"
                          v-model="new_user_model.password"
                          :append-icon="show1 ? 'visibility' : 'visibility_off'"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                          :rules="rules.required"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="editedIndex == -1">
                        <v-text-field
                          label="Confirm Password"
                          v-model="conf_password"
                          :append-icon="show1 ? 'visibility' : 'visibility_off'"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                          :rules="passwordConfirmationRules"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 v-if="editedIndex != -1">
                        <v-text-field
                          label="New Password"
                          v-model="new_user_model.password"
                          :append-icon="show1 ? 'visibility' : 'visibility_off'"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                          hint="At least 8 characters"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          label="Role"
                          :items="[
                            'administrator',
                            'accountant',
                            'entry_clerk',
                            'vendor',
                          ]"
                          v-model="new_user_model.role"
                          :rules="rules.required"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-card>
            </template>

            <template v-slot:modal-actions>
              <v-btn class="error" text @click.stop="closeUForm()">Close</v-btn>
              <v-btn class="success" text @click="saveuser()" :loading="busy"
                >Save</v-btn
              >
            </template>
          </modalDialog>
          <v-btn
            color="primary"
            style="margin-bottom: 10px"
            @click="openUForm()"
          >
            <v-icon>add</v-icon>Add Staff
          </v-btn>

          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-card>
                <v-card-title style="background: #eee">
                  <h4>Staffs</h4>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="usertbl_headers"
                    :items="user_list"
                    class="elevation-0"
                    :search="search"
                    :loading="busy"
                  >
                    <template v-slot:item.phone="{ item }">
                      {{ item.phone ? item.phone : "N/A" }}
                    </template>

                     <template v-slot:item.status="{ item }">
                      {{ item.active&&item.active == 1
                            ? "Active"
                            : "Disabled"}}
                    </template>

                    <template v-slot:item.actions={item,index}>
                       <v-layout row wrap>
                          <v-flex xs6>
                            <v-btn
                              text
                              icon
                              color="blue"
                              @click.native="edituser(item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-flex>

                          <v-flex xs6>
                            <v-btn
                              text
                              icon
                              color="pink"
                              @click.native="
                                deleteuser(item,index)
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                    </template>


                    <!-- <template v-slot:items="props">
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-center">
                        {{ props.item.phone ? props.item.phone : "N/A" }}
                      </td>
                      <td class="text-xs-center">{{ props.item.email }}</td>
                      <td class="text-xs-center">{{ props.item.role }}</td>
                      <td class="text-xs-center">
                        {{
                          props.item.active && props.item.active == 1
                            ? "Active"
                            : "Disabled"
                        }}
                      </td>
                      <td class="text-xs-center">
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-btn
                              text
                              icon
                              color="blue"
                              @click.native="edituser(props.item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-flex>

                          <v-flex xs6>
                            <v-btn
                              text
                              icon
                              color="pink"
                              @click.native="
                                deleteuser(props.item, props.index)
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template> -->
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
    <snackbar ref="sb"></snackbar>
  </v-layout>
</template>

<script>
import UserService from "../../services/user-service";
import modalDialog from "../shared/modal_dialog";
import snackbar from "../shared/snackbar";
export default {
  components: {
    modalDialog,
    snackbar,
  },

  data() {
    return {
      valid: true,
      lazy: false,
      show1: false,
      busy: false,
      rules: {
        required: [(value) => !!value || "Required."],
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match",
        emailConfirmationRules: [
          (v) => !!v || "Confirmation E-mail is required",
          (v) => v == this.email || "E-mail must match",
        ],
      },
      conf_password: "",
      new_user_model: {
        name: "",
        phone: "",
        email: "",
        password: "",
        role: "",
        active: "1",
      },
      search: "",
      editedIndex: -1,
      acc_status: false,
      dialog: false,
      show_sale_new_user_form: true,
      // new_user_model: {
      //   name: "",
      //   phone: "",
      //   email: "",
      //   password:"",
      //   role: ""
      // },

      usertbl_headers: [
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "Phone No.",
          align: "center",
          sortable: false,
          value: "phone",
        },
        {
          text: "Email",
          align: "center",
          sortable: false,
          value: "email",
        },
        {
          text: "Role",
          align: "center",
          sortable: false,
          value: "role",
        },
        {
          text: "Acct. Status",
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      user_list: [],

      // new_user_model: {
      //   name: "",
      //   phone: "",
      //   email: "",
      //   password: "",
      //   conf_password: "",
      //   role: "",
      //   active: "1"
      // }
    };
  },
  created() {
    //this.initialisePage()
    this.loadUsers();
  },
  computed: {
    passwordConfirmationRules() {
      //let c1 = (this.conf_password != null || this.conf_password != "")
      return [
        this.new_user_model.password === this.conf_password ||
          "passwords must match",
      ];
    },
  },
  methods: {
    async setActiveInActive(item, index) {
      var thesnackbar = this.$refs.sb;
      let vm = this;
      this.busy = true;
      if (item.active == 1) {
        await UserService.updateUserStatus(item.id, 0).then((response) => {
          //console.log(response);
          item.active = response.data.status;
          vm.snackbarconf(
            thesnackbar,
            "User account DEACTIVATED successfully",
            "success"
          );
        });
      } else {
        await UserService.updateUserStatus(item.id, 1).then((response) => {
          console.log(response);
          item.active = response.data.status;
          vm.snackbarconf(
            thesnackbar,
            "User account ACTIVATED successfully",
            "success"
          );
        });
      }
      this.busy = false;
    },
    loadUsers() {
      this.busy = true;
      UserService.getAll()
        .then((response) => {
          this.user_list = response.data;
          // console.log(user_list)

          // console.log(this.items)
          this.busy = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.busy = false;
        });
    },
    adduser() {
      var thesnackbar = this.$refs.sb;
      let vm = this;
      if (this.new_user_model.name) {
        // this.user_list.unshift(this.new_user_model)
        UserService.create(this.new_user_model)
          .then((response) => {
            this.new_user_model.id = response.data.id;
            this.user_list.unshift(this.new_user_model);
            this.new_user_model = {
              name: "",
              phone: "",
              email: "",
              password: "",
              role: "",
              active: "1",
            };

            this.$toast.success("User Accounted CREACTED Successfully");
            //console.log(response.data);
            this.busy = false;
          })
          .catch((error) => {
            this.$toast.error(
              "Sorry,An error occured and user account could not be created."
            );
            this.busy = false;
            console.log(error.response);
          });
      }
    },
    deleteuser(item, index) {
      this.busy = true;
      var thesnackbar = this.$refs.sb;
      let vm = this;
      //console.log(item)
      if (confirm("Are you sure you want to delete this user?")) {
        UserService.delete(item.id)
          .then((response) => {
            this.busy = false;
            this.$delete(this.user_list, index);
            this.$toast.success("User Accounted DELETED Successfully");
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(
              "Sorry,An error occured and user account could not be deleted."
            );
            this.busy = false;
            console.log(error.response);
          });
      }
    },
    edituser(item) {
      this.editedIndex = this.user_list.indexOf(item);
      this.new_user_model = Object.assign({}, item);
      this.new_user_model.password = "";
      // console.log(this.selectedStockGroup);
      this.openUForm();
    },
    updateuser(item, index) {
      // this.editedIndex = this.user_list.indexOf(item)
      var vm = this;
      this.busy = true;
      UserService.update(item.id, item)
        .then((response) => {
          this.busy = false;
          Object.assign(this.user_list[index], item);
          this.editedIndex = -1;
          this.$toast.success("User Accounted UPDATED Successfully");
          console.log(response.data);
        })
        .catch((error) => {
          this.$toast.error(
            "Sorry,An error occured and user account could not be updated."
          );
          this.busy = false;
          console.log(error);
        });

      // console.log(this.selectedStockGroup);

      this.closeUForm();
    },
    saveuser() {
      //decides between editing user info or saving user info

      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.updateuser(this.new_user_model, this.editedIndex);
        } else {
          this.adduser();
        }
      }
    },
    openUForm() {
      if (this.editedIndex > -1) {
        this.fm_title = "Edit User";
      } else {
        this.fm_title = "New User";
      }
      var vm = this;
      vm.$refs.userfm.open();
    },
    closeUForm() {
      var vm = this;
      vm.new_user_model = {
        name: "",
        phone: "",
        email: "",
        password: "",
        role: "",
        active: "1",
      };
      this.editedIndex = -1;
      vm.$refs.userfm.close();
    },
    snackbarconf(snackbar, message, color) {
      snackbar.text = message;
      snackbar.color = color;
      snackbar.snackbar = true;
    },
  },
};
</script>